import { useTranslation } from "react-i18next";

function EmptyTableView() {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col items-center justify-center py-12 text-onsurface/60">
            <svg
                className="size-12"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path d="M3 9h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9Z" />
                <path d="m3 9 2.45-4.9A2 2 0 0 1 7.24 3h9.52a2 2 0 0 1 1.8 1.1L21 9" />
                <path d="M12 3v6" />
            </svg>
            <p className="mt-4 text-sm">
                {t('companies.table.noResults')}
            </p>
        </div>
    );
}

export default EmptyTableView;